import { computed } from 'vue'
import { useFetchCalendarStaffsQuery } from './useCalendar.generated.ts'
import type { OAuthProvider } from '@/types/schema.generated.ts'

export type StaffType = {
  guid: string
  displayName: string
  connectedThirdPartyProvider: OAuthProvider | undefined
}

export const useCalendar = () => {
  const { result, refetch } = useFetchCalendarStaffsQuery({
    fetchPolicy: 'no-cache',
  })

  const isCalendarAvailable = computed(() => {
    if (!result.value) {
      return undefined
    }

    return result.value.staffsByPlanner.some(
      staff => staff.connectedThirdPartyProvider
    )
  })

  const linkedStaffs = computed<StaffType[] | undefined>(() => {
    if (!result.value) {
      return undefined
    }

    return result.value.staffsByPlanner
      .filter(staff => staff.connectedThirdPartyProvider)
      .map(s => ({
        guid: s.guid,
        displayName: s.displayName,
        connectedThirdPartyProvider: s.connectedThirdPartyProvider ?? undefined,
      }))
  })

  return {
    linkedStaffs,
    isCalendarAvailable,
    refetch,
  }
}
